import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"

import { Alert, Form, Input, FormFeedback, Label, Card, CardBody, CardTitle, CardText } from "reactstrap"
//redux
import { useSelector, useDispatch } from "react-redux"

import { Link } from "react-router-dom"
import withRouter from "../../components/Common/withRouter"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// actions
import { loginUser, socialLogin } from "../../store/actions"

// import images
import logo from "../../assets/images/logo.png"

//Import config
import { facebook } from "../../config"
import { isAnyValueEmpty } from "../../components/Common/CommonLogic"
import * as schema from "../../api/global-schema"
import { ToastWrapper } from "../../components/Common/CustomToast"
import { authBackground } from "../../assets/images"

const UserLogin = props => {
    localStorage.removeItem("isNetworkLogin");
    const [passwordShow, setPasswordShow] = useState(false)
    const wrapperRef = useRef(null);
    const [cardHeight, setCardHeight] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        if (wrapperRef.current) {
            setCardHeight(wrapperRef.current.offsetHeight);
        }
    }, []);

    const { error } = useSelector(state => ({
        error: state.Login.error,
    }))

    useEffect(() => {
        console.log(props);
    }, [props]);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            validateonmount: true,
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            email: schema.email,
            password: schema.password,
        }),
        onSubmit: async (values) => {
            let dataObj = {
                "user-name": values?.email,
                'password': values?.password,
                "remember-me": "false"
            }
            dispatch(loginUser(dataObj, props.router.navigate));
        }
    });
    const handleAgentLogin = () => {
        window.location.href = process.env.REACT_APP_SHIPPER_FRONTEND_URL+"/login";
    };
    document.title = "Login || Navigating Freight Costs with Precision||Ultimate Rate Management platform"

    return (
        <React.Fragment>
            <div className="blurred-background-wrapper">
                <div className="blurred-background" />
                <div className="content">
                    <div className="card-wrapper">
                        {/* className="card-back" */}
                        <div style={{ height: `${cardHeight}px`, }} />
                        <div className="d-flex justify-content-center align-items-center vh-100">
                            <div ref={wrapperRef}>
                                <Card className="shadow p-4" style={{ minWidth: '460px', maxWidth: '460px' }}>
                                    <CardBody>
                                        <div id="welcome" className="mb-2 text-center" style={{ marginBottom: 0 }}>
                                            <Link to="/dashboard" className="d-block auth-logo">
                                                <img src={logo} alt="Logo" height="64" style={{
                                                    display: "block",
                                                    margin: "0 auto",
                                                    padding: 0,
                                                    lineHeight: 1,
                                                    verticalAlign: "middle",
                                                    border: "none",
                                                    maxHeight: "64px",
                                                }} />
                                            </Link>
                                        </div>
                                        <CardTitle tag="h4" className="text-center mb-2">Welcome back 👋</CardTitle>
                                        <CardText className="text-center text-muted mb-4">Please sign in to your account</CardText>
                                        <Form
                                            className="custom-form tf_common_form mt-4 pt-2"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            {error ? <Alert color="danger">{error}</Alert> : null}

                                            <div id="enterEmailAddresArea" className="mb-3">
                                                <Label className="form-label">Email address</Label>
                                                <Input
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="Enter email address"
                                                    type="email"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.email || ""}
                                                    invalid={
                                                        validation.touched.email && validation.errors.email ? true : false
                                                    }
                                                />
                                                {validation.touched.email && validation.errors.email ? (
                                                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                ) : null}
                                            </div>
                                            <div className="mb-3">
                                                <div className="d-flex align-items-start">
                                                    <div className="flex-grow-1">
                                                        <Label className="form-label">Password</Label>
                                                    </div>
                                                </div>
                                                <div id="enterPasswordArea" className="input-group auth-pass-inputgroup">
                                                    <Input
                                                        name="password"
                                                        value={validation.values.password || ""}
                                                        type={passwordShow ? "text" : "password"}
                                                        placeholder="Enter password"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        invalid={
                                                            validation.touched.password && validation.errors.password ? true : false
                                                        }
                                                    />
                                                    <button onClick={() => setPasswordShow(!passwordShow)} className={`btn btn-light shadow-none ms-0 ${passwordShow ? 'show' : ''}`} type="button" id="password-addon"></button>
                                                    {validation.touched.password && validation.errors.password ? (
                                                        <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                    ) : null}
                                                </div>
                                                <div className="d-flex align-items-start">
                                                    <div className="flex-grow-1">
                                                    </div>
                                                    <div className="flex-shrink-0">
                                                        <div className="forgot_pass_text">
                                                            <Link to="/page-recoverpw" className="text-muted">Forgot password?</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col">
                                                    <div className="mt-3 d-grid">
                                                        <button className={`btn btn-primary btn-block ${(!validation.isValid || isAnyValueEmpty(validation.values)) ? 'disabled' : ''}`} type="submit" disabled={!validation.isValid || isAnyValueEmpty(validation.values)} > Log In </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                        <p className="text-center text-muted mt-3">
                                            Don’t have an account? <a href="/register">Sign up</a>
                                        </p>
                                        <p className="text-center text-muted mt-3">
                                            Login As?{' '}
                                            <Link onClick={handleAgentLogin} className="text-primary hover:underline">
                                                Shipper
                                            </Link>
                                        </p>
                                    </CardBody>
                                </Card>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            <ToastWrapper />
        </React.Fragment>
    )
}

export default withRouter(UserLogin);

UserLogin.propTypes = {
    history: PropTypes.object,
}
